<template>
  <div class="role-page">
    <div class="features f-r-vc">
      <el-button
        type="primary"
        class="feature-button depp-green-bg"
        @click="openRoleeDialog(null)"
      >
        <svg-icon icon-class="plus" class="svg-white-color" />
        Create Role
      </el-button>
    </div>
    <div class="role-list">
      <searchable-table
        v-loading="loadingTable"
        :table-headers="RoleTableHeaders"
        :table-data="roleQuery"
        :search-params="searchForm"
        :search-param-change="searchParamChange"
        :has-actions="true"
      >
        <template v-slot:actions="props">
          <el-button
            size="small"
            type="text"
            @click="openRoleeDialog(props.row)"
          >
            Edit
          </el-button>
          <el-button size="small" type="text" @click="deleteRole(props.row)">
            Delete
          </el-button>
        </template>
      </searchable-table>
    </div>
    <role-create-or-update ref="roleDialog" :formInputInit="InitRoleForm" />
  </div>
</template>
<script>
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'
// apis
import { createRole, queryRole, updateRole, removeRole } from '@/api/role'
// models
import {
  RoleTableHeaders,
  RoleSearchForm,
  InitRoleForm,
  RoleSearchParamsWrapUp
} from '@/core/models/role'
// components
import RoleCreateOrUpdate from '@/components/admin/role/RoleCreateOrUpdate.vue'
import SearchableTable from '@/components/common/SearchableTable.vue'
export default {
  name: 'RolePage',
  components: {
    SearchableTable,
    RoleCreateOrUpdate
  },
  data() {
    return {
      RoleTableHeaders,
      RoleSearchForm,
      loadingTable: false,
      roleQuery: null,
      searchForm: cloneDeep(RoleSearchForm)
    }
  },
  mounted() {
    this.doSearch()
  },
  methods: {
    InitRoleForm,
    createRoleCb(data) {
      createRole(data).then(res => {
        if (res) {
          this.$message.success('Create role successfully!')
          this.doSearch()
        }
      })
    },
    updateRoleCb(data) {
      updateRole(data).then(res => {
        if (res) {
          this.$message.success('Update role successfully!')
          this.doSearch()
        }
      })
    },
    deleteRole(data) {
      this.$confirm(`Delete role ${data.name}, continue?`, 'Confirm', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          removeRole(data.id).then(res => {
            if (res) {
              this.$message.success('Delete role successfully!')
              this.doSearch()
            }
          })
        })
        .catch(() => {})
    },
    openRoleeDialog(data) {
      this.$refs.roleDialog.open(
        data,
        data ? this.updateRoleCb : this.createRoleCb
      )
    },
    searchParamChange(key, path, value) {
      set(this.searchForm[key], path, value)
      this.doSearch()
    },
    doSearch() {
      const params = RoleSearchParamsWrapUp(this.searchForm)
      queryRole(params).then(res => {
        this.roleQuery = res
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.role-page {
  width: 100%;
  overflow-x: hidden;

  .features {
    @extend .global-margin;
  }

  @extend .f-c;

  .role-list {
    @extend .global-margin;
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }
}
</style>
